import { createContext } from "react";

export const Gender = Object.freeze({
  FEMALE: "FEMALE",
  MALE: "MALE",
});
export const Region = Object.freeze({
  LK: "LK",
  NON_LK: "NON_LK",
});
export const LK_FILTER_VALUE = "Sri Lanka";
export const DEFAULT_FONT_FAMILY = `'Noto Sans Sinhala Variable', sans-serif`;

const Config = {
  PAGE_NUMBERS_START: 5,
  NO_OF_AD_COLUMNS_PER_PAGE: 4,
  NO_OF_AD_ROWS_PER_PAGE: 9,
  GENDER_PRIORITY: [Gender.FEMALE, Gender.MALE],
  REGION_PRIORITY: [Region.LK, Region.NON_LK],
  HEADER: {
    MONTH_LABEL: "February | 2025",
    GENDER_LABEL: {
      [Gender.FEMALE]: "BRIDES - මනාලියන්",
      [Gender.MALE]: "GROOMS - මනාලයන්",
    },
  },
};

const MagazineConfig = createContext(Config);
export default MagazineConfig;
